"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DefaultInfoButtonIcon12: function() {
        return DefaultInfoButtonIcon12;
    },
    DefaultInfoButtonIcon16: function() {
        return DefaultInfoButtonIcon16;
    },
    DefaultInfoButtonIcon20: function() {
        return DefaultInfoButtonIcon20;
    }
});
const _reacticons = require("@fluentui/react-icons");
const DefaultInfoButtonIcon12 = (0, _reacticons.bundleIcon)(_reacticons.Info12Filled, _reacticons.Info12Regular);
const DefaultInfoButtonIcon16 = (0, _reacticons.bundleIcon)(_reacticons.Info16Filled, _reacticons.Info16Regular);
const DefaultInfoButtonIcon20 = (0, _reacticons.bundleIcon)(_reacticons.Info20Filled, _reacticons.Info20Regular);
